import { Outlet, ScrollRestoration, useMatches } from "react-router-dom"

import { SkipLink } from "@/components/common/skip-link"
import { Header } from "@/components/common/header"
import { Breadcrumb } from "@/components/common/breadcrumb"
import { Footer } from "@/components/common/footer"
import { ModalRoot } from "@/components/common/modal-root"
import { HaptikChatFab } from "@/components/common/haptik-chat-fab"
import { AnalyticsPageTracker } from "@/lib/analytics/page-tracker"

interface RouteHandle {
  crumb?: string
}

/**
 * Single shared layout for every route (migration plan §1.3/§2.4). Every
 * legacy page hand-copied its own header/footer/modal markup with drift
 * between them; this consolidates that into one composition.
 */
export function AppLayout() {
  const matches = useMatches()
  const current =
    [...matches]
      .reverse()
      .map((m) => (m.handle as RouteHandle | undefined)?.crumb)
      .find(Boolean) ?? "Reliance Foundation Scholarships"

  return (
    <div className="flex min-h-dvh flex-col">
      <AnalyticsPageTracker />
      <SkipLink />
      <Header />
      <Breadcrumb current={current} />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ModalRoot />
      <HaptikChatFab />
      <ScrollRestoration />
    </div>
  )
}
